import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import StylePopup from '../stylePopup/stylePopup';
import SpeedPopup from '../speedPopup/speedPopup';
@Component({
  components: {
    StylePopup,
    SpeedPopup
  },
})
export default class SpeakerInfo extends Vue {
  @Prop() currSpeaker: any
  @Prop() speakerEmotionCacheVOList: any
  @Prop() querySpeakerInfo: any
  @Prop() theme: string
  arrowRightIcon = require('/public/images/migu/arrow_right_icon.png')
  showStylePopup = false
  showSpeedPopup = false
  
  moodName = '默认'
  currSpeed = '1.0'
  @Watch('querySpeakerInfo',  {deep: true, immediate: true})
  listenQuerySpeakerInfo(val) {
    this.moodName = val.speakerStyle
    this.currSpeed = val.speechSpeed
  }
  @Watch('currSpeaker.name')
  listenSpeakerName(oldName, newName) {
    console.log('listenSpeakerName', newName)
    if (newName && newName !== oldName) {
      this.moodName = '默认'
      this.currSpeed = '1.0'
    }
  }
  useSpeaker() {
    const info = {
      speakerName: this.currSpeaker.name,
      speakerStyle: this.moodName,
      speechSpeed: this.currSpeed
    }
    localStorage.setItem('textToVideoMiguData', JSON.stringify(info))
    this.$router.go(-1)
  }
  confirmStyle(moodName) {
    this.moodName = moodName
    this.showStylePopup = false
  }
  confirmSpeed(speed) {
    this.currSpeed = speed
    this.showSpeedPopup = false
  }
}